export const BetAmountArea = {
	name: 'BET_AMOUNT_AREA',
	position: {
		x: 0,
		y: 0
	},
	components: [
		{
			name: 'BET_AMOUNT_BG',
			type: 'Sprite',
			img: 'bet_amount_bg',
			position: {
				x: -5,
				y: 0
			}
		},
		{
			name: 'BET_AMOUNT_TEXT',
			type: 'Text',
			position: { x: 24, y: 24 },
			text: 'BET_AMOUNT_TITLE'
		},
		{
			name: 'BET_AMOUNT_VALUE',
			type: 'Text',
			position: { x: 22, y: 40 },
			text: 'BET_AMOUNT_VALUE'
		}
	]
};
